import React, { Component } from 'react';
import Header from '../layout/Header';

export class Our_expert extends Component {
    render() {
        return (
            <div className="site-main">
                <Header />
                {/* page-title */}
                <div className="ttm-page-title-row">
                    <div className="container-xl">
                    <div className="row">
                        <div className="col-md-12"> 
                        <div className="title-box text-center">
                            <div className="page-title-heading">
                            <h1 className="title">Our Expert</h1>
                            </div>{/* /.page-title-captions */}
                            <div className="breadcrumb-wrapper">
                            <span>
                                <a title="Homepage" href={process.env.PUBLIC_URL + '/'}><i className="ti ti-home" />&nbsp;&nbsp;Home</a>
                            </span>
                            <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                            <span>Our Expert</span>
                            </div>  
                        </div>
                        </div>{/* /.col-md-12 */}  
                    </div>{/* /.row */}  
                    </div>{/* /.container */}                      
                </div>
                {/* page-title end*/}
                <section className="ttm-row grid-section clearfix">
                    <div className="container-xl">
                    {/* row */}
                    <div className="row">
                        <div className="col-md-6 col-lg-4 col-sm-6">
                        {/* featured-imagebox-team */}
                        <div className="featured-imagebox featured-imagebox-team style1 mb-30">
                            <div className="featured-thumbnail">{/* featured-thumbnail */}
                            <img className="img-fluid" src="https://via.placeholder.com/480X520/444444.jpg" alt="image" />
                            <div className="ttm-social-links-wrapper">
                                <ul className="social-icons list-inline">{/* social-icons */}
                                    <li className="social-facebook"><a><i className="fab fa-facebook-f" /></a></li>
                                    <li className="social-twitter"><a><i className="fab fa-twitter" /></a></li>
                                    <li className="social-linkedin"><a><i className="fab fa-linkedin-in" /></a></li>
                                    <li className="social-googleplus"><a><i className="fab fa-google-plus-g" /></a></li>
                                </ul>
                            </div>
                            </div> 
                            <div className="featured-content box-shadow">
                            <div className="featured-title">{/* featured-title */}
                                <h5><a href={process.env.PUBLIC_URL + '/Team_detail'}>Jennifer Garcia</a></h5>
                            </div>
                            <p className="category">IT Service Officer</p>{/* category */}
                            </div>
                        </div>{/* featured-imagebox-team end*/}
                        </div>
                        <div className="col-md-6 col-lg-4 col-sm-6">
                        {/* featured-imagebox-team */}
                        <div className="featured-imagebox featured-imagebox-team style1 mb-30">
                            <div className="featured-thumbnail">{/* featured-thumbnail */}
                            <img className="img-fluid" src="https://via.placeholder.com/480X520/444444.jpg" alt="image" />
                            <div className="ttm-social-links-wrapper">
                                <ul className="social-icons list-inline">{/* social-icons */}
                                    <li className="social-facebook"><a><i className="fab fa-facebook-f" /></a></li>
                                    <li className="social-twitter"><a><i className="fab fa-twitter" /></a></li>
                                    <li className="social-linkedin"><a><i className="fab fa-linkedin-in" /></a></li>
                                    <li className="social-googleplus"><a><i className="fab fa-google-plus-g" /></a></li>
                                </ul>
                            </div>
                            </div> 
                            <div className="featured-content box-shadow">
                            <div className="featured-title">{/* featured-title */}
                                <h5><a href={process.env.PUBLIC_URL + '/Team_detail'}>Robert Liam</a></h5>
                            </div>
                            <p className="category">Web Designer</p>{/* category */}
                            </div>
                        </div>{/* featured-imagebox-team end*/}
                        </div>
                        <div className="col-md-6 col-lg-4 col-sm-6">
                        {/* featured-imagebox-team */}
                        <div className="featured-imagebox featured-imagebox-team style1 mb-30">
                            <div className="featured-thumbnail">{/* featured-thumbnail */}
                            <img className="img-fluid" src="https://via.placeholder.com/480X520/444444.jpg" alt="image" />
                            <div className="ttm-social-links-wrapper">
                                <ul className="social-icons list-inline">{/* social-icons */}
                                    <li className="social-facebook"><a><i className="fab fa-facebook-f" /></a></li>
                                    <li className="social-twitter"><a><i className="fab fa-twitter" /></a></li>
                                    <li className="social-linkedin"><a><i className="fab fa-linkedin-in" /></a></li>
                                    <li className="social-googleplus"><a><i className="fab fa-google-plus-g" /></a></li>
                                </ul>
                            </div>
                            </div> 
                            <div className="featured-content box-shadow">
                            <div className="featured-title">{/* featured-title */}
                                <h5><a href={process.env.PUBLIC_URL + '/Team_detail'}>Jessica Ethan</a></h5>
                            </div>
                            <p className="category">Project Manager</p>{/* category */}
                            </div>
                        </div>{/* featured-imagebox-team end*/}
                        </div>
                        <div className="col-md-6 col-lg-4 col-sm-6">
                        {/* featured-imagebox-team */}
                        <div className="featured-imagebox featured-imagebox-team style1 mb-30">
                            <div className="featured-thumbnail">{/* featured-thumbnail */}
                            <img className="img-fluid" src="https://via.placeholder.com/480X520/444444.jpg" alt="image" />
                            <div className="ttm-social-links-wrapper">
                                <ul className="social-icons list-inline">{/* social-icons */}
                                    <li className="social-facebook"><a><i className="fab fa-facebook-f" /></a></li>
                                    <li className="social-twitter"><a><i className="fab fa-twitter" /></a></li>
                                    <li className="social-linkedin"><a><i className="fab fa-linkedin-in" /></a></li>
                                    <li className="social-googleplus"><a><i className="fab fa-google-plus-g" /></a></li>
                                </ul>
                            </div>
                            </div> 
                            <div className="featured-content box-shadow">
                            <div className="featured-title">{/* featured-title */}
                                <h5><a href={process.env.PUBLIC_URL + '/Team_detail'}>Amanda Brown</a></h5>
                            </div>
                            <p className="category">Consultant Officer</p>{/* category */}
                            </div>
                        </div>{/* featured-imagebox-team end*/}
                        </div>
                        <div className="col-md-6 col-lg-4 col-sm-6">
                        {/* featured-imagebox-team */}
                        <div className="featured-imagebox featured-imagebox-team style1 mb-30">
                            <div className="featured-thumbnail">{/* featured-thumbnail */}
                            <img className="img-fluid" src="https://via.placeholder.com/480X520/444444.jpg" alt="image" />
                            <div className="ttm-social-links-wrapper">
                                <ul className="social-icons list-inline">{/* social-icons */}
                                    <li className="social-facebook"><a><i className="fab fa-facebook-f" /></a></li>
                                    <li className="social-twitter"><a><i className="fab fa-twitter" /></a></li>
                                    <li className="social-linkedin"><a><i className="fab fa-linkedin-in" /></a></li>
                                    <li className="social-googleplus"><a><i className="fab fa-google-plus-g" /></a></li>
                                </ul>
                            </div>
                            </div> 
                            <div className="featured-content box-shadow">
                            <div className="featured-title">{/* featured-title */}
                                <h5><a href={process.env.PUBLIC_URL + '/Team_detail'}>Enna Mason</a></h5>
                            </div>
                            <p className="category">Product Analyst</p>{/* category */}
                            </div>
                        </div>{/* featured-imagebox-team end*/}
                        </div>
                        <div className="col-md-6 col-lg-4 col-sm-6">
                        {/* featured-imagebox-team */}
                        <div className="featured-imagebox featured-imagebox-team style1 mb-30">
                            <div className="featured-thumbnail">{/* featured-thumbnail */}
                            <img className="img-fluid" src="https://via.placeholder.com/480X520/444444.jpg" alt="image" />
                            <div className="ttm-social-links-wrapper">
                                <ul className="social-icons list-inline">{/* social-icons */}
                                    <li className="social-facebook"><a><i className="fab fa-facebook-f" /></a></li>
                                    <li className="social-twitter"><a><i className="fab fa-twitter" /></a></li>
                                    <li className="social-linkedin"><a><i className="fab fa-linkedin-in" /></a></li>
                                    <li className="social-googleplus"><a><i className="fab fa-google-plus-g" /></a></li>
                                </ul>
                            </div>
                            </div> 
                            <div className="featured-content box-shadow">
                            <div className="featured-title">{/* featured-title */}
                                <h5><a href={process.env.PUBLIC_URL + '/Team_detail'}>John Bruce</a></h5>
                            </div>
                            <p className="category">IT Associative</p>{/* category */}
                            </div>
                        </div>{/* featured-imagebox-team end*/}
                        </div>
                    </div>
                    {/* row end*/}
                    </div>
                </section>
            </div>
            )
    }
}


export default Our_expert;